import React from "react";
import FormGroup from "@mostrans/web-components/components/base/FormGroup";
import IconButton from "@mostrans/web-components/components/base/IconButton";
import Input from "@mostrans/web-components/components/base/Input";
import { Icon, Button } from "@mui/material";
import { useRecoilState } from "recoil";
import { cloneDeep } from "lodash";

import { valueInputJobRequirementAtoms } from "../../../../shared/atoms/getValueInputAtoms";

function FormAddRequirements() {
  const [requirementsValue, setRequirementsValue] = useRecoilState(
    valueInputJobRequirementAtoms
  );

  const addRowRequirement = () => {
    setRequirementsValue([...requirementsValue, { job_requirement: "" }]);
  };

  const handleChangeRequirementsValue = (i, e) => {
    setRequirementsValue((prevRequiremetValue) => {
      let newRequirmentsValue = cloneDeep(prevRequiremetValue);
      newRequirmentsValue[i][e.target.name] = e.target.value;
      return newRequirmentsValue;
    });
  };

  const removeRequuirementsRow = (i) => {
    const newRequirmentsValue = [...requirementsValue];
    newRequirmentsValue.splice(i, 1);
    setRequirementsValue(newRequirmentsValue);
  };

  return (
    <>
      {requirementsValue.map((element, index) => (
        <div className="form-row mb-1">
          <div className="col-md-11">
            <FormGroup>
              <Input
                type="text"
                name="job_requirement"
                onChange={(e) => handleChangeRequirementsValue(index, e)}
                placeholder={`Entry Jobs Requirement ${index + 1}`}
                multiline={2}
              />
            </FormGroup>
          </div>
          {index ? (
            <div className="col-md-1">
              <IconButton onClick={() => removeRequuirementsRow(index)}>
                <Icon>remove_circle_outline</Icon>
              </IconButton>
            </div>
          ) : null}
        </div>
      ))}
      <div className="form-row mb-1">
        <div className="col-md-6">
          <Button size="small" onClick={() => addRowRequirement()}>
            Add Job Requirements Row
          </Button>
        </div>
      </div>
    </>
  );
}

export default FormAddRequirements;
